(function () {
    'use strict';


    angular
        .module('tikonApp')
        .controller('GeneralServiceItemV2Controller', GeneralServiceItemV2Controller);

    GeneralServiceItemV2Controller.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'ServiceItem', 'ServiceOptionInfo', 'DiscountInfo', 'LocationInfo', 'AlbumInfo', 'ServiceCapacityInfo', 'ServiceCategory', 'PriceInfo', 'ScheduleInfo', 'Servant', 'AgreementInfo', 'MetaTag', 'ServiceCategoryCustom', 'CompanyCustom', '$translate', '$translatePartialLoader', '$state', 'ServiceItemCustom', 'Principal'];

    function GeneralServiceItemV2Controller($timeout, $scope, $stateParams, entity, ServiceItem, ServiceOptionInfo, DiscountInfo, LocationInfo, AlbumInfo, ServiceCapacityInfo, ServiceCategory, PriceInfo, ScheduleInfo, Servant, AgreementInfo, MetaTag, ServiceCategoryCustom, CompanyCustom, translate, translatePartialLoader, $state, ServiceItemCustom, Principal) {
        var vm = this;
        vm.scope = $scope;
        vm.scheduleFormState = 'list';
        vm.priceInfoFormState = "'list'";
        vm.serviceOptionInfoFormState = "'list'";
        vm.servantFormState = "'list'";
        vm.serviceItem = entity;
        vm.oldItem = angular.copy(vm.serviceItem);
        vm.mainScheduleType = 'SERVICE_SCHEDULE';
        vm.saveAndGotoScheduling = saveAndGotoScheduling;
        vm.weekDayExists = weekDayExists;
        vm.toggleWeekDay = toggleWeekDay;
        vm.weekDays = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
        // vm.isCopyChecked = false;

        //vm.clear = clear;
        vm.save = save;
        vm.categoryName = categoryName;
        vm.showFullDescription = showFullDescription;
        vm.fullDescription = false;
        vm.showAdvancedSetting = showAdvancedSetting;
        vm.advancedSetting = false;
        vm.showDuration = showDuration;
        vm.confirmationType_Change = confirmationType_Change;
        if (vm.serviceItem.multiReserveMode == undefined)
            vm.serviceItem.multiReserveMode = "DISABLE";
        vm.serviceColors = ['COLOR0', 'COLOR1', 'COLOR2', 'COLOR3', 'COLOR4', 'COLOR5'];
        vm.hasServant = hasServant;
        vm.hasServants = false;
        vm.showOnMarketPlace = false;
        vm.findMarketPlacePublishStatusStyle = findMarketPlacePublishStatusStyle;
        vm.findMarketPlacePublishStatusIcon = findMarketPlacePublishStatusIcon;

        vm.showMarketPlaceSection = false;
        vm.isVideoMeeting = false;
        vm.meetingCheckChange = meetingCheckChange;
        vm.hasAccesToTwoStpeFeature = false;
        vm.isEventMode = false;
        vm.backToList = backToList;
        initDefault();
        vm.paymentType_changed = paymentType_changed;
        vm.priceInfoFormReload = false;
        vm.getArrowClass = getArrowClass;
        vm.autoApprove_Changed = autoApprove_Changed;
        findCurrentCompany();


        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {


            vm.servicecategories = result;
            if (vm.serviceItem.category == null || vm.serviceItem.category == undefined || vm.serviceItem.category.id == null || vm.serviceItem.category.id == undefined) {
                angular.forEach(result, function (category) {

                    if (category.categoryName == "DEFAULT_CATEGORY") {
                        vm.serviceItem.category = category;
                    }

                });
            }

            angular.forEach(vm.servicecategories, function (category) {

                    category.categoryName = categoryName(category.categoryName)
                }
            );


            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('marketPlacePublishStatus');
            translatePartialLoader.addPart('paymentDeadlineType');
            translatePartialLoader = translate.refresh();

        });

        if (vm.serviceItem.maxPreReserveTime == null || vm.serviceItem.maxPreReserveTime == undefined)
            vm.serviceItem.maxPreReserveTime = 30;
        if (vm.serviceItem.minPreReserveTime == null || vm.serviceItem.minPreReserveTime == undefined)
            vm.serviceItem.minPreReserveTime = 0;


        // $timeout(function () {
        //     angular.element('.form-group:eq(1)>input').focus();
        // });


        if (vm.serviceItem.amenities == null || vm.serviceItem.amenities == undefined) {
            vm.serviceItem.amenities = {};
            vm.serviceItem.amenities.amenitiesList = [];
        }


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;
                if (vm.currentCompany.activityType == 'WORK_SPACE') {
                    vm.priceInfoType = "fixed";
                }
            });
        }


        //
        //function clear () {
        //    $uibModalInstance.dismiss('cancel');
        //}

        function save() {
            updateScheduleTypeFromMainType();
            checkIfScheduleRegenerationNeeded();
            updateMarketPlaceInfo();
            vm.priceInfoFormReload = 'false';


            if (vm.scope.serviceItemForm.$valid) {
                vm.isSaving = true;

                if (vm.serviceItem.id !== null) {

                    ServiceItem.update(vm.serviceItem, onSaveSuccess, onSaveError);
                } else {
                    ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);

                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:serviceItemUpdate', result);

            ServiceItem.get({id: result.id}).$promise.then(function (serv) {
                vm.serviceItem = serv;
                vm.oldItem = angular.copy(vm.serviceItem);
                //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : result.scheduleInfo.id});
                //$uibModalInstance.close(result);

                vm.priceInfoFormReload = 'true';
                vm.priceInfoFormState = 'list';
                vm.serviceOptionInfoFormState = 'list';
                vm.isSaving = false;
                vm.hasServant();
            });


            // if (vm.nextGotoScheduling) {
            //     $state.go('supplierPanel.scheduling', {id: vm.serviceItem.id});
            // }

        }

        function backToList() {

            vm.scheduleFormState = 'list';
            vm.selectedScheduleId = '';
        }

        function onSelectedScheduleChanged(data) {

            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : data.id});

        }

        function onCreateNewSchedule() {

            vm.serviceItem.scheduleInfo = {};

        }

        function onCreateNewPriceInfo() {
            //

            vm.serviceItem.priceInfo = {};

        }

        function onSelectedPriceInfoChanged(data) {
            //
            //vm.serviceItem.priceInfo= PriceInfo.get({id : data.id});

        }

        function onSaveError() {
            vm.isSaving = false;
            vm.nextGotoScheduling = false;
        }


        function paymentType_changed() {

            if (vm.serviceItem.paymentType == "PAYMENT_ALL") {
                vm.serviceItem.prePaymentAmount = 0;
            }
            if (vm.serviceItem.paymentType == "PRE_PAYMENT") {
                vm.serviceItem.inPlacePayment = false;
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function showFullDescription() {
            vm.fullDescription = !vm.fullDescription;
        }

        function showAdvancedSetting() {
            vm.advancedSetting = !vm.advancedSetting;
            canAccessTwoStepFeature();
        }

        function initDefault() {


            if (vm.serviceItem.serviceStatus == null || vm.serviceItem.serviceStatus == undefined)
                vm.serviceItem.serviceStatus = 'PUBLISH';

            if (vm.serviceItem.paymentType == null || vm.serviceItem.paymentType == undefined)
                vm.serviceItem.paymentType = 'PAYMENT_ALL';

            if (vm.serviceItem.confirmationType == null || vm.serviceItem.confirmationType == undefined)
                vm.serviceItem.confirmationType = 'ONE_STEP';

            if (vm.serviceItem.capacityInfo == null || vm.serviceItem.capacityInfo == undefined || vm.serviceItem.capacityInfo.qty == null || vm.serviceItem.capacityInfo.qty == undefined) {
                vm.serviceItem.capacityInfo = {};
                vm.serviceItem.capacityInfo.qty = 1;
                vm.serviceItem.capacityInfo.qtyUnit = 'نفر';
                vm.serviceItem.capacityInfo.minQty = 1;
            } else {
                if (!vm.serviceItem.capacityInfo.qtyUnit) {
                    vm.serviceItem.capacityInfo.qtyUnit = 'نفر';

                }
                if (!vm.serviceItem.capacityInfo.minQty)
                    vm.serviceItem.capacityInfo.minQty = 1;
            }

            if (!vm.serviceItem.duration)
                vm.serviceItem.duration = 60;
            if (!vm.serviceItem.gapTime)
                vm.serviceItem.gapTime = 0;
            if (!vm.serviceItem.consecutiveReserveMode)
                vm.serviceItem.consecutiveReserveMode = 'DISABLE';


            if (vm.serviceItem.color == null)
                vm.serviceItem.color = 'COLOR0';


            if (vm.serviceItem.prePaymentAmount == null)
                vm.serviceItem.prePaymentAmount = 0;

            if (vm.serviceItem.servantSelectMode == null)
                vm.serviceItem.servantSelectMode = 'SELECT_BY_CUSTOMER';

            if (vm.serviceItem.showOnMarketPlaceStatus == null || vm.serviceItem.showOnMarketPlaceStatus == 'NOT_SHOW')
                vm.showOnMarketPlace = false;
            else
                vm.showOnMarketPlace = true;

            if (!vm.serviceItem.paymentDeadlineType)
                vm.serviceItem.paymentDeadlineType = 'UNTIL_RESERVE_TIME';

            if (!vm.serviceItem.customerConfirmationDeadline)
                vm.serviceItem.customerConfirmationDeadline = 24;

            if (vm.serviceItem.serviceMode && vm.serviceItem.serviceMode == "EVENT") {
                vm.isEventMode = true;
                vm.serviceItem.servantSelectMode = 'SELECT_BY_CUSTOMER';
            }

            setMainScheduleType();

            hasServant();
            checkMarketPlaceInfo();
            setMeetingType();

            //must run last

        }

        function setMainScheduleType() {
            if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
                var currentType = vm.serviceItem.scheduleInfo.scheduleType;
                if (currentType == 'SERVICE_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
                    vm.mainScheduleType = 'SERVICE_SCHEDULE';
                    if (vm.serviceItem.consecutiveReserveMode != 'DISABLE')
                        vm.serviceItem.consecutiveReserveMode = 'ENABLE';
                } else if (currentType == 'FIXED_TIME_SESSIONS') {
                    vm.mainScheduleType = 'FIXED_TIME_SESSIONS';
                } else {
                    vm.mainScheduleType = 'SERVICE_SCHEDULE';
                }
            }
        }

        function updateScheduleTypeFromMainType() {

            if (vm.serviceItem.scheduleInfo == null)
                vm.serviceItem.scheduleInfo = {};

            vm.serviceItem.scheduleInfo.scheduleType = vm.mainScheduleType;

            //if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
            //    var currentType = vm.serviceItem.scheduleInfo.scheduleType;
            //    if (currentType == 'SERVICE_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
            //        if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
            //            currentType = 'FIXED_TIME_SESSIONS'
            //        }
            //
            //    } else if (currentType == 'FIXED_TIME_SESSIONS') {
            //        if (vm.mainScheduleType != 'FIXED_TIME_SESSIONS')
            //            currentType = 'SERVICE_SCHEDULE';
            //    } else {
            //        currentType = 'SERVICE_SCHEDULE';
            //    }
            //    vm.serviceItem.scheduleInfo.scheduleType = currentType;
            //} else {
            //    var currentType = 'SERVICE_SCHEDULE';
            //    if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
            //        currentType = 'FIXED_TIME_SESSIONS'
            //    }
            //    if (!vm.serviceItem.scheduleInfo)vm.serviceItem.scheduleInfo = {};
            //    vm.serviceItem.scheduleInfo.scheduleType = currentType;
            //}
        }

        function saveAndGotoScheduling() {
            vm.nextGotoScheduling = true;
            vm.save();
        }

        function checkIfScheduleRegenerationNeeded() {
            vm.serviceItem.scheduleGenerationNeeded = true;
            return;
            vm.scheduleGenerationNeeded = false;
            if (vm.oldItem && vm.oldItem.scheduleInfo && vm.serviceItem && vm.serviceItem.scheduleInfo && vm.oldItem.scheduleInfo.scheduleType != vm.serviceItem.scheduleInfo.scheduleType) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.duration != vm.serviceItem.duration ||
                (vm.oldItem.capacityInfo && vm.oldItem.capacityInfo.qty != vm.serviceItem.capacityInfo.qty) ||
                vm.oldItem.maxPreReserveTime != vm.serviceItem.maxPreReserveTime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.gaptime != vm.serviceItem.gaptime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else {
                //checking servants
                if (vm.oldItem.servants.length != vm.serviceItem.servants.length)
                    vm.serviceItem.scheduleGenerationNeeded = true;
                else {
                    if (vm.oldItem.servants.length > 0) {
                        angular.forEach(vm.oldItem.servants, function (os) {
                            var isInList = false;
                            angular.forEach(vm.serviceItem.servants, function (ns) {
                                if (ns.id == os.id)
                                    isInList = true;
                            });
                            if (!isInList)
                                vm.serviceItem.scheduleGenerationNeeded = true;
                        })
                    }
                }

            }
        }

        function showDuration() {

            if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS')
                return false;

            if (vm.serviceItem == null || vm.serviceItem.serviceTimes == null)
                return true;

            if (vm.serviceItem.serviceTimes != null && vm.serviceItem.serviceTimes != undefined
                && vm.serviceItem.serviceTimes.length == 1 && vm.serviceItem.serviceTimes[0].scheduleType == 'SERVICE_SCHEDULE'
            ) {
                return true;
            }

        }

        function confirmationType_Change() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'TWO_STEP'

            ) {
                if (vm.serviceItem.customerConfirmationDeadline == null || vm.serviceItem.customerConfirmationDeadline == undefined || vm.serviceItem.customerConfirmationDeadline == 0) {
                    vm.serviceItem.customerConfirmationDeadline = 24;
                }
            }

            checkDeadLineStates();
        }


        function autoApprove_Changed() {
            checkDeadLineStates();
        }

        function checkDeadLineStates() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'ONE_STEP') {
                vm.serviceItem.paymentDeadline = false;
            }
        }

        function weekDayExists(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            var isExist = false;
            if (selectedWeekDay != undefined)
                angular.forEach(selectedWeekDay, function (item) {
                    if (item == weekDay)
                        isExist = true;
                });
            return isExist;

        }

        function toggleWeekDay(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            if (selectedWeekDay == undefined)
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays = [];

            if (vm.weekDayExists(weekDay, selectedWeekDay)) {
                var index = selectedWeekDay.indexOf(weekDay);
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.splice(index, 1);
            } else {
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.push(weekDay);
            }

        }

        function getColorClass(color) {
            return color;

        }

        function hasServant() {
            if (vm.serviceItem.servants != null && vm.serviceItem.servants.length > 0) {
                vm.hasServants = true;
            } else {
                vm.hasServants = false;
            }
        }

        function updateMarketPlaceInfo() {

            if (vm.showOnMarketPlace)
                vm.serviceItem.showOnMarketPlaceStatus = 'SHOW'
            else
                vm.serviceItem.showOnMarketPlaceStatus = 'NOT_SHOW'


            //in every save if showOnMarketPlaceStatus = 'SHOW' must set marketPlacePublishStatus = 'REQUESTED'

            if (vm.serviceItem.showOnMarketPlaceStatus == 'SHOW') {
                vm.serviceItem.marketPlacePublishStatus = 'REQUESTED'
            } else {
                vm.serviceItem.marketPlacePublishStatus = null;
            }


        }

        function findMarketPlacePublishStatusStyle() {

            return "market-place-publish-status-" + vm.serviceItem.marketPlacePublishStatus;
        }

        function findMarketPlacePublishStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-flash";
            }
            if (status == "WAITING") {
                return "glyphicon glyphicon-time";
            }
            if (status == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "DENIED") {
                return "glyphicon glyphicon-remove";
            }

        }

        function checkMarketPlaceInfo() {
            vm.showMarketPlaceSection = false;
            if (vm.serviceItem.id && vm.serviceItem.category.company.activityType == 'WORK_SPACE') {
                vm.showMarketPlaceSection = false;
            }
        }

        function meetingCheckChange() {
            if (vm.isVideoMeeting) {
                vm.serviceItem.meetingType = 'RW_VIDEO_CALL';
            } else
                vm.serviceItem.meetingType = null;
        }

        function setMeetingType() {
            if (vm.serviceItem.meetingType && vm.serviceItem.meetingType == 'RW_VIDEO_CALL') {
                vm.isVideoMeeting = true;
            } else {
                vm.isVideoMeeting = false;
            }
        }

        function canAccessTwoStepFeature() {
            vm.hasAccesToTwoStpeFeature = Principal.hasSpecialFeatureAccess('twoStepVerification');
        }

        function backToList() {
            if (vm.isEventMode)
                $state.go('supplierPanel.serviceItemEventListV2', {id: vm.serviceItem.id});
            else
                $state.go('supplierPanel.serviceItemListV2', {id: vm.serviceItem.id});
        }

        function getArrowClass() {
            if (vm.advancedSetting)
                return 'arrow-animate';
            else
                return 'arrow-animate-left';
        }

    }
})();
